<template>
  <el-form :label-position="'top'" :model="loginForm" :rules="loginRules" ref="loginForm" label-width="60px"  >
    <el-row :gutter='0' style="text-align: center">
      <el-col><h2>美钥二维码登录</h2></el-col>
    </el-row>
    <el-form-item label="邮箱" prop="j_username">
      <el-input v-model="loginForm.j_username" placeholder="Email"></el-input>
    </el-form-item>

    <el-form-item label="密码" prop="j_password">
      <el-input v-model="loginForm.j_password" type="password" placeholder="Password"></el-input>
    </el-form-item>
    
    <el-form-item prop="j_remember_me">
      <el-checkbox v-model="loginForm.j_remember_me">一个月内自动登录</el-checkbox>
      <router-link to="/user/forgotpassword" style="float: right">忘记密码</router-link>
    </el-form-item>
    <el-form-item>
        <el-button class="formBtn" type="primary" @click="submitForm('loginForm')">立即登录</el-button>  
    </el-form-item>
    <el-form-item>
        <div class="line-dashed"></div>
        <p class="text-muted"><small>还没有账户?</small></p>
        <el-button class="formBtn" @click="routeToRegister">马上注册</el-button>  
    </el-form-item>
  </el-form>
</template>

<script type="text/javascript">
import $ from 'jquery'
export default {
  name: 'loginForm',
  data () {
    return {
      loginForm: {
        j_username: '',
        j_password: '',
        j_remember_me: true
      },
      loginRules: {
        j_username: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', required: true, message: '请输入可用的邮件地址', trigger: 'blur' },
          { max: 50, message: '您的用户名至多包含50个字符', trigger: 'blur' }
        ],
        j_password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '您的密码需要至少包含6个字符', trigger: 'blur' },
          { max: 40, message: '您的密码至多包含40个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      const vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          $.ajax({
            type: 'POST',
            url: '/v1/user/login/process',
            dataType: 'json',
            async: true,
            data: {
              'username': vm.loginForm.j_username,
              'password': vm.loginForm.j_password,
              'remember-me': vm.loginForm.j_remember_me
            },
            success: function (data) {
              if (data.code === 200) {
                vm.$message.success('☺ 您好，' + vm.loginForm.j_username)
                vm.$router.push('/qrmanage')
              } else if (data.code === 200001) {
                vm.$message.error('用户名不存在，请确认后重新输入！')
              } else if (data.code === 200002) {
                vm.$message.error('密码错误，请确认后重新输入！')
                vm.j_password = ''
              } else if (data.code === 200003) {
                vm.$message.error('账户被锁定，请联系工作人员！')
              } else if (data.code === 200004) {
                // TODO: 因为目前无法解决message中嵌入html问题，所以，只能直接跳转
                // vm.$message.error('您需要先<a style="color:blue" href="/user/register/resend">激活邮箱</a>才能登录！')
                vm.$message.error('您需要先进行账号激活操作!')
                vm.$router.push('/user/register/resend')
              } else {
                vm.$message.error('登录异常，请稍后重试')
              }
            },
            error: function (XMLHttpRequest, textStatus) {
              if (textStatus === 'timeout') {
                vm.$message.error('响应超时，请稍后重试')
              } else {
                vm.$message.error('登录异常，请稍后重试')
              }
            }
          })
        } else {
          return false
        }
      })
    },
    routeToRegister () {
      this.$router.push('/user/register')
    }
  }
}
</script>

<style type="text/css" scoped>
.formBtn {
  width: 100%;
}

.line-dashed{
  *width: 100%;
  height: 2px;
  font-size:0;
  overflow: hidden;
  background-color: #fff;
  border-width:0;
  border-top: 1px solid #e0e4e8;
  border-style: dashed;
  background: transparent;
}

.text-muted{
  color: #919599;
  margin: 0;
  text-align: center;
}
</style>
